import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IDocument } from 'app/models/documents/document';
import { Observable } from 'rxjs';
import { IDocumentType } from 'app/models/documents/documentType';

@Injectable({providedIn: 'root'})
export class DocumentService {
  public api: string = environment.privateApi + 'Document/'
  private http = inject(HttpClient);

  getDocumentTypes(): Observable<IDocumentType[]>{
    return this.http.get<IDocumentType[]>(this.api + 'GetDocumentTypes');
  }

  getDocuments(entityId: number, entityType: string, includeArchived: boolean): Observable<IDocument[]>{
    return this.http.get<IDocument[]>(this.api + 'GetDocuments/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  uploadDocument(file: FormData, entityType: string): Observable<IDocument>{
    return this.http.post<IDocument>(this.api + 'UploadDocument/' + entityType, file)
  }

  downloadDocument(documentId: number): Observable<Blob>{
    return this.http.get<Blob>(this.api + "DownloadDocument/" + documentId, { responseType: 'blob' as 'json' })
  }

  archiveDocument(documentId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveDocument/' + documentId + '/' + archive, null);
  }

  deleteDocument(documentId: number): Observable<any>{
    return this.http.delete<any>(this.api + "DeleteDocument/" + documentId)
  }
}
